export const IS_LOGIN = "IS_LOGIN";
export const AUTH_LOADING = "AUTH_LOADING";
export const AUTH_ERROR = "AUTH_ERROR";
export const SET_USER = "SET_USER";
export const DESTROY_SESSION = "DESTROY_SESSION";
export const VERIFY_TOKEN = "VERIFY_TOKEN";

export const ASSISTANT_LOADING = "ASSISTANT_LOADING";
export const ASSISTANT_ERROR = "ASSISTANT_ERROR";
export const SET_ASSISTANT = "SET_ASSISTANT";

export const SET_ASSISTANTS = "SET_ASSISTANTS";
// Separate from ASSISTANT_LOADING, which every assistant request shares: the
// switcher has to know whether *the list* is in flight, not whether something
// somewhere is.
export const ASSISTANTS_LOADING = "ASSISTANTS_LOADING";
export const SET_ACTIVE_ASSISTANT = "SET_ACTIVE_ASSISTANT";
